/**
 * MultiDiseaseWelcomePage - Intermediate page for multi-disease experiment users
 *
 * Shows the experiment modal after payment, before the questionnaire.
 * - If user continues → navigate to questionnaire
 * - If user cancels → process cancellation, navigate home
 */

import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_QUESTIONNAIRE_V2 } from '@/constants/routes';
import { MultiDiseaseExperimentModal } from '@/components/multi-disease-experiment-modal';
import { usePaywallDetection } from '@/components/payment-paywall-modal';

export default function MultiDiseaseWelcomePage() {
  const navigate = useNavigate();
  const { subscriptionId } = usePaywallDetection();

  // Handle user continuing (dismiss modal)
  const handleDismiss = useCallback(() => {
    navigate(ROUTE_QUESTIONNAIRE_V2, { replace: true });
  }, [navigate]);

  // Handle user cancelling their trial
  // Still navigate to questionnaire - they have access for the remainder of their trial
  const handleCancelled = useCallback(() => {
    navigate(ROUTE_QUESTIONNAIRE_V2, { replace: true });
  }, [navigate]);

  // If somehow user lands here without being in the cohort, redirect to questionnaire
  // This is a fallback - normally payment flow handles this
  useEffect(() => {
    const cohort = sessionStorage.getItem('payment_cohort');
    if (cohort !== 'multi-disease') {
      navigate(ROUTE_QUESTIONNAIRE_V2, { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <MultiDiseaseExperimentModal
        subscriptionId={subscriptionId}
        onDismiss={handleDismiss}
        onCancelled={handleCancelled}
      />
    </div>
  );
}
